define('collections/creativeNetStatuses',["T1", "T1Collection"], function (T1, T1Collection) {
  T1.Models.CreativeNetStatuses = T1Collection.extend({
    canCache: false,
    urlString: "atomic_creatives/creative_healthcheck"
  });
  return T1.Models.CreativeNetStatuses;
});
